import { useEffect } from 'react';
import { bridge } from 'shared/src/utils';
import { localStorageBridge } from 'shared/src/utils';
import type { RecentKeywordItem } from '../SearchHelper.page';

export const useLogViewEvent = () => {
  useEffect(() => {
    const logEvent = async () => {
      const stored = await localStorageBridge.getString('KEY_RECENT_SEARCH');
      const parsed: RecentKeywordItem[] = stored ? JSON.parse(stored) : [];
      const items = parsed.filter(item => !item.is_delete);

      bridge.logAnalyticsEvent({
        name: 'VIEW_SEARCH',
        channel: ['firebase', 'amplitude', 'ablylog'],
        analytics: {
          SCREEN: 'SEARCH',
          HAS_BANNER: items.length === 0 ? '1' : '0',
        },
      });
    };

    logEvent();
  }, []);
};
